import React from "react";

/** Догрузка следующей страницы опций при скролле выпадающего списка до низа. */
export const handlePopupScrollBottom =
  (callback: () => void) => (e: React.UIEvent<HTMLDivElement>) => {
    const target = e.target as HTMLDivElement;
    if (target.scrollTop + target.clientHeight >= target.scrollHeight - 20) {
      callback();
    }
  };
